import styled, { css } from 'styled-components/macro';
import { transparentize } from 'polished';

import { definitionLabel } from 'styles/base-classes';
import theme from 'styles/themes/variables';
import colors from 'styles/themes/colors';
import modularScale from 'styles/helpers/modular-scale';
import Anchor from 'components/base/Anchor/Anchor';

const leftAlignedTooltip = css`
  margin-left: -2em;

  &:before {
    left: 2em;
  }
`;

const rightAlignedTooltip = css`
  margin-left: -20.5em;

  &:before {
    left: 20.5em;
  }
`;

const TooltipContainer = styled.div<any>`
  width: 22.5em;
  position: relative;
  margin-left: -11.25em;
  transform: translateY(1em);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0.25em 1.5em -0.25em ${transparentize(0.8, colors.NightBlue)};
  border-radius: 0.25em;

  &:before {
    content: '';
    position: absolute;
    left: 50%;
    top: -0.5em;
    margin-left: -0.6em;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0.6em 0.6em 0.6em;
    border-color: transparent transparent rgba(255, 255, 255, 0.8) transparent;
  }

  ${({ isLeftAligned }: any): any => isLeftAligned && leftAlignedTooltip};
  ${({ isRightAligned }: any): any => isRightAligned && rightAlignedTooltip};
`;

const MobileTooltipContainer = styled.div`
  border: 1px solid ${colors.LightGrey};
  margin: ${theme.spacing.medium} 0;
`;

const TooltipContent = styled.div`
  padding: 0 ${theme.spacing.medium};
  font-size: ${modularScale(-1)};

  @media screen and (min-width: 45em) {
    font-size: ${modularScale(0)};
  }

  svg {
    max-width: 1.25em;
    max-height: 1.25em;
    height: auto;
  }
`;

const MobileTooltipContent = styled(TooltipContent)`
  border-top: 1px solid ${colors.LightGrey};
`;

const TooltipTitle = styled(TooltipContent)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const MobileTooltipTitle = styled(TooltipTitle)`
  margin: ${theme.spacing.small} 0;
`;

const Label = styled.h3`
  ${definitionLabel};
  margin: ${theme.spacing.large} 0 ${theme.spacing.small};
`;

const TooltipTop = styled(TooltipContent)`
  border-bottom: 1px solid ${colors.LightGrey};
`;

const Content = styled.p`
  margin: ${theme.spacing.small} 0;
`;

const Faded = styled(Content)`
  color: ${colors.CasperGrey};
  margin: ${theme.spacing.small} 0;
`;

const FormattedDate = styled(Faded)`
  font-size: ${modularScale(-1)};
`;

const SemiBold = styled.span`
  font-weight: 600;
`;

const Value = styled(SemiBold)`
  color: ${colors.NightBlue};
  margin-left: 0.5ch;
`;

const ShowMore = styled(SemiBold)`
  color: ${colors.DeepBlue};
  padding: 0;
`;

const TooltipBottom = styled(TooltipContent)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: ${colors.DeepBlue};
  margin: ${theme.spacing.small} 0 0;
  padding-bottom: ${theme.spacing.small};

  svg {
    margin-right: 0.5ch;
  }
`;

const MobileTitleContent = styled.span`
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;

  svg {
    margin-right: 0.5ch;
  }
`;

const TopPostAnchor = styled(Anchor)`
  border-bottom: 0;
  padding-bottom: 0;
  color: ${colors.AccentGreen};
  box-shadow: none;
  float: right; /* yes, floats */
`;

export {
  Content,
  Faded,
  FormattedDate,
  Label,
  MobileTitleContent,
  MobileTooltipContainer,
  MobileTooltipContent,
  MobileTooltipTitle,
  SemiBold,
  ShowMore,
  TooltipBottom,
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
  TooltipTop,
  TopPostAnchor,
  Value,
};
